import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register Service Worker pour le mode PWA / offline (en dev ET en prod, via REACT_APP_ENABLE_SW=0 pour désactiver)
if ('serviceWorker' in navigator && process.env.REACT_APP_ENABLE_SW !== '0') {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/service-worker.js')
      .then((reg) => {
        console.log('SW registered:', reg.scope);
        // Force update check au load (utile si nouvelle version déployée)
        reg.update().catch(() => null);
      })
      .catch((err) => console.warn('SW registration failed:', err));
  });
}
